export default "__VITE_ASSET__CXmKE4o___"